// Mock data for Alpielec website

export const companyInfo = {
  name: "Alpielec",
  tagline: "Électricité & Travaux en Hauteur",
  description: "Expert en travaux d'électricité et cordiste professionnel au Pays Basque",
  email: "contact@alpielec.fr",
  phone: "06 10 95 26 31",
  location: "Pays Basque",
  baseLocation: "Basé à Urrugne",
  logo: "/images/logo-alpielec.png"
};

export const cordisteServices = [
  {
    id: "haute-tension",
    title: "Travaux Haute Tension",
    description: "Intervention sur installations électriques haute tension en hauteur avec sécurité maximale",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1764925925904-66da3bffecba"
  },
  {
    id: "relamping",
    title: "Relamping",
    description: "Remplacement et maintenance d'éclairages en hauteur, optimisation énergétique par accès sur corde",
    icon: "Lightbulb",
    image: "/images/relamping.jpg"
  },
  {
    id: "maconnerie",
    title: "Reprise de Maçonnerie",
    description: "Travaux de maçonnerie en hauteur, réparation et rénovation de façades",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1761625291169-44e97331f370"
  },
  {
    id: "port-charge",
    title: "Port de Charge",
    description: "Manutention et transport de charges en hauteur en toute sécurité",
    icon: "Package",
    image: "https://images.unsplash.com/photo-1758836113725-a1b082c622bd"
  },
  {
    id: "petits-travaux",
    title: "Petits Travaux en Hauteur",
    description: "Tous types de petits travaux nécessitant un accès par corde",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1763478545926-e988846846f7"
  }
];

export const electricienServices = [
  {
    id: "conformite",
    title: "Remises en Conformité",
    description: "Mise aux normes de vos installations électriques selon les réglementations en vigueur",
    icon: "CheckCircle",
    image: "/images/maison-moderne.png"
  },
  {
    id: "depannage",
    title: "Dépannages",
    description: "Intervention rapide pour tous vos problèmes électriques, 7j/7",
    icon: "Wrench",
    image: "/images/tableau-electrique.jpg"
  },
  {
    id: "renovation",
    title: "Rénovations",
    description: "Rénovation complète de vos installations électriques anciennes",
    icon: "RefreshCw",
    image: "/images/renovation.jpg"
  },
  {
    id: "travaux-neufs",
    title: "Travaux Neufs",
    description: "Installation électrique complète pour constructions neuves",
    icon: "Home",
    image: "/images/maison-basque-trad.jpg"
  }
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1595856619767-ab739fa7daae",
  cordiste: "https://images.unsplash.com/photo-1766448979403-8a071dae1619",
  electricien: "/images/tableau-electrique.jpg"
};

export const testimonials = [
  {
    id: 1,
    name: "Caroline Zarza",
    text: "Intervention rapide, travail soigné et très professionnel. M. Levot a été ponctuel et à l'écoute. Le chantier a été laissé propre et les délais ont été respectés. Un service de qualité avec un bon rapport qualité/prix. Je n'hésiterai pas à faire appel à nouveau à lui et à le recommander autour de moi. Merci pour votre sérieux, sympathie et votre efficacité !",
    rating: 5,
    source: "Google"
  },
  {
    id: 2,
    name: "Louis Roussel",
    text: "Je recommande! François a été très professionnel et consciencieux et a répondu à toutes nos attentes pour mener à bien notre projet de rénovation",
    rating: 5,
    source: "Google"
  },
  {
    id: 3,
    name: "Geoffrey (Escape Feeling)",
    text: "Un grand merci à François pour le travail réalisé. Réactif, dynamique et sérieux, nous sommes ravis d'avoir choisi François pour réaliser notre installation électrique. Il s'adapte à toutes les demandes que nous avons pu lui faire. Un artisan que je recommande les yeux fermés ! À très vite et merci pour tout 🤝",
    rating: 5,
    source: "Google"
  },
  {
    id: 4,
    name: "Quentin Avril",
    text: "Faire appel à ALPIELEC, c'est travailler avec un professionnel aguerri, de très bon conseils et qui pratique un tarif cohérent. Qui plus est, François est très sympathique. Nous le recommandons vivement !",
    rating: 5,
    source: "Google"
  },
  {
    id: 5,
    name: "Marie-Liesse Couette",
    text: "Merci François pour ton travail chez nous. En plus, ce n'est pas faute de t'avoir fait revenir à plusieurs étapes du chantier global et tu t'es toujours arrangé! Merci de nous avoir fait découvrir les boutons à distance, la révolution haha ! Et merci aussi pour ton écoute et ton dynamisme.",
    rating: 5,
    source: "Google"
  }
];
